export default __webpack_public_path__ + "static/2122-6bc5b21962a8e6d2b4cf36a87fa9363e.gif";